import { supabase } from '../lib/supabase';

export async function saveSearch({
  name,
  model,
  parameter,
  startDate,
  endDate,
  polygon,
  resolution,
  userId
}: {
  name: string;
  model: string;
  parameter: string;
  startDate: string;
  endDate: string;
  polygon: any;
  resolution: number;
  userId: string;
}) {
  const { data, error } = await supabase
    .from('saved_searches')
    .insert({
      name,
      model,
      parameter,
      start_date: startDate,
      end_date: endDate,
      polygon,
      resolution,
      user_id: userId
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function fetchSavedSearches(userId: string) {
  const { data, error } = await supabase
    .from('saved_searches')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data;
}

export async function deleteSavedSearch(id: string) {
  const { error } = await supabase
    .from('saved_searches')
    .delete()
    .eq('id', id);

  if (error) throw error;
}